export const NOTIFICATION_PAGE_SHOW = 'PAYMENTS/NOTIFICATION/PAGE_SHOW';
export const NOTIFICATION_MODAL_SHOW = 'PAYMENTS/NOTIFICATION/MODAL_SHOW';
export const NOTIFICATION_CLOSE = 'PAYMENTS/NOTIFICATION/CLOSE_ALL';
export const NOTIFICATION_CLOSE_ON_CLICK = 'PAYMENTS/NOTIFICATION/CLOSE_SINGLE';
export const STACKED_NOTIFICATION_PAGE_SHOW = 'PAYMENTS/STACKED_NOTIFICATION/PAGE_SHOW';
export const STACKED_NOTIFICATION_MODAL_SHOW = 'PAYMENTS/STACKED_NOTIFICATION/MODAL_SHOW';
export const STACKED_NOTIFICATION_CLOSE = 'PAYMENTS/STACKED_NOTIFICATION/CLOSE_ALL';

export const showPageNotification = (name: string, extraArgs?: Record<string, unknown>) => ({
  type: NOTIFICATION_PAGE_SHOW,
  payload: {
    name,
    extraArgs,
  },
});

export const showModalNotification = (name: string, extraArgs?: Record<string, unknown>) => ({
  type: NOTIFICATION_MODAL_SHOW,
  payload: {
    name,
    extraArgs,
  },
});

export const closeNotification = () => ({
  type: NOTIFICATION_CLOSE,
});

export const closeNotificationOnClick = () => ({
  type: NOTIFICATION_CLOSE_ON_CLICK,
});

export const showStackedPageNotification = (name: string, extraArgs?: Record<string, unknown>) => ({
  type: STACKED_NOTIFICATION_PAGE_SHOW,
  payload: {
    name,
    extraArgs,
  },
});

export const showStackedModalNotification = (name: string, extraArgs?: Record<string, unknown>) => ({
  type: STACKED_NOTIFICATION_MODAL_SHOW,
  payload: {
    name,
    extraArgs,
  },
});

export const stackedCloseNotification = (name: string) => ({
  type: STACKED_NOTIFICATION_CLOSE,
  payload: {
    name,
  },
});
